var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E633059D-3398-4D27-A133-506CB7DB1658") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-home",
    transform: "translate(-766, -602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(754, 602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "headset_mic-icon",
    transform: "translate(12, 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333333,30.6666667 C16.9556,30.6666667 16.6389333,30.5389333 16.3833333,30.2833333 C16.1277333,30.0277333 16,29.7110667 16,29.3333333 C16,28.9556 16.1277333,28.6389333 16.3833333,28.3833333 C16.6389333,28.1277333 16.9556,28 17.3333333,28 L25.3333333,28 L25.3333333,26.6666667 L22.6666667,26.6666667 C21.9333333,26.6666667 21.3056,26.4056 20.7833333,25.8833333 C20.2610667,25.3610667 20,24.7333333 20,24 L20,18.6666667 C20,17.9333333 20.2610667,17.3056 20.7833333,16.7833333 C21.3056,16.2610667 21.9333333,16 22.6666667,16 L25.3333333,16 L25.3333333,14.6666667 C25.3333333,12.0888933 24.4222667,9.88889333 22.6,8.06666667 C20.7777333,6.24444 18.5777333,5.33333333 16,5.33333333 C13.4222667,5.33333333 11.2222267,6.24444 9.4,8.06666667 C7.57777333,9.88889333 6.66666667,12.0888933 6.66666667,14.6666667 L6.66666667,16 L9.33333333,16 C10.0666667,16 10.69444,16.2610667 11.2166667,16.7833333 C11.7388933,17.3056 12,17.9333333 12,18.6666667 L12,24 C12,24.7333333 11.7388933,25.3610667 11.2166667,25.8833333 C10.69444,26.4056 10.0666667,26.6666667 9.33333333,26.6666667 L6.66666667,26.6666667 C5.93333333,26.6666667 5.30556,26.4056 4.78333333,25.8833333 C4.26110667,25.3610667 4,24.7333333 4,24 L4,14.6666667 C4,13.0222267 4.31666667,11.4722267 4.95,10.0166667 C5.58333333,8.56110667 6.44444,7.28889333 7.53333333,6.2 C8.62222667,5.11110667 9.89444,4.25 11.35,3.61666667 C12.80556,2.98333333 14.3556,2.66666667 16,2.66666667 C17.6444,2.66666667 19.1944,2.98333333 20.65,3.61666667 C22.1056,4.25 23.3777333,5.11110667 24.4666667,6.2 C25.5556,7.28889333 26.4166667,8.56110667 27.05,10.0166667 C27.6833333,11.4722267 28,13.0222267 28,14.6666667 L28,28 C28,28.7333333 27.7389333,29.3610667 27.2166667,29.8833333 C26.6944,30.4056 26.0666667,30.6666667 25.3333333,30.6666667 L17.3333333,30.6666667 Z M6.66666667,24 L9.33333333,24 L9.33333333,18.6666667 L6.66666667,18.6666667 L6.66666667,24 Z M22.6666667,24 L25.3333333,24 L25.3333333,18.6666667 L22.6666667,18.6666667 L22.6666667,24 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.a78fdd7e29d3e856e91bbc37bb86c2d7.svg";
export { ForwardRef as ReactComponent };